import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const VepsInProgressTitleColumns = () => (
    <>
        <GridTable.Data>
            <I18n component="span" id="vep.payment.number" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="vep.payment.date" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="vep.payment.cuitCreator" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="vep.payment.cuitTaxpayer" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="vep.payment.description" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="vep.payment.amount" />
        </GridTable.Data>
        <GridTable.Data alignX="center">
            <I18n component="span" id="vep.payment.status" />
        </GridTable.Data>
        <GridTable.Data />
    </>
);
export default VepsInProgressTitleColumns;
